<div class="main-container">
  <div class="grid-container" id="dc-report-grid-container">
    <div class="top-toolbar">
      <div class="float-left ml-2">
        @if (taxyearLoaded) {
          <ap-dropdown class="tax-year-dropdown" [list]="taxYearItems" [selectType]="'single'" [title]="'Tax Year'"
            [hideTitleOnInput]="true" [inputAriaLabel]="'Tax Year'" [(ngModel)]="selectedTaxYearItem"
            (onSelect)="onTaxYearChanged($event)">
            @for (item of taxYearItems; track item.value) {
              <ap-dropdown-list-item #dropdownListItem [item]="item" [ariaLabel]="setTaxYearAriaLabel(item)"
                (onSelectItem)="onTaxYearSelectItem($event)"></ap-dropdown-list-item>
            }
          </ap-dropdown>
        }

        <button class="export-btn" (click)="exportToExcel()">
          <i class="Appkit4-icon icon-save-outline"></i>
          Export to Excel
        </button>
      </div>
    </div>

    <div class="dst-mat-grid-layout">
      @if (loading) {
        <div class="dst-mat-grid-loading">
          <mat-spinner [diameter]="40"></mat-spinner>
        </div>
      }
      <div class="dst-mat-grid">
        <table mat-table [dataSource]="dataSource" [fixedLayout]="true" matSort class="dst-mat-table data-collect-table">
          <ng-container matColumnDef="TAXYEAR">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(getColByField('TAXYEAR'))">
              {{ getColByField('TAXYEAR').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" [ngStyle]="getColStyle(getColByField('TAXYEAR'))"
              style="text-align: center;">
              <span>{{ rowData.TAXYEAR }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="STATEMENTID">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(getColByField('STATEMENTID'))">
              {{ getColByField('STATEMENTID').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" style="overflow: visible;"
              [ngStyle]="getColStyle(getColByField('STATEMENTID'))">
              <a href="javascript:void(0);" (click)="showViewUpdateStatement(rowData)">
                <span>{{ rowData.STATEMENTID }}</span>
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="STATEMENTNAME">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getColStyle(getColByField('STATEMENTNAME'))">
              {{ getColByField('STATEMENTNAME').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap"
              [ngStyle]="getColStyle(getColByField('STATEMENTNAME'))">
              <span>{{ rowData.STATEMENTNAME }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="DATACOLLECT_ACTION_FLAG">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getColStyle(getColByField('DATACOLLECT_ACTION_FLAG'))">
              {{ getColByField('DATACOLLECT_ACTION_FLAG').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" style="text-align: center;"
              [ngStyle]="getColStyle(getColByField('DATACOLLECT_ACTION_FLAG'))">
              <span>{{ rowData.DATACOLLECT_ACTION_FLAG }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="DATACOLLECT_ACTION_EXPL">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="getColStyle(getColByField('DATACOLLECT_ACTION_EXPL'))">
              {{ getColByField('DATACOLLECT_ACTION_EXPL').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="text-pre-wrap"
              [ngStyle]="getColStyle(getColByField('DATACOLLECT_ACTION_EXPL'))">
              <span>{{ rowData.DATACOLLECT_ACTION_EXPL }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="REVIEWNAME">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(getColByField('REVIEWNAME'))">
              {{ getColByField('REVIEWNAME').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="item-aligned"
              [ngStyle]="getColStyle(getColByField('REVIEWNAME'))">
              @if (rowData.DATACOLLECT_ACTION_FLAG === 'Yes' && rowData.REVIEWNAME !== 'N/A') {
                <div class="row">
                  @if (rowData.REVIEWNAME !== 'N/A') {
                    <div class="col-md-10 pr-0 rev-Expl">
                      <ap-dropdown class="field-full-width" [list]="rowData['revExplanations_' + rowData.id]"
                        [selectType]="'single'" [showSearchbox]="true" [title]="'Select'" [hideTitleOnInput]="true"
                        [inputAriaLabel]="'Select'" [(ngModel)]="rowData.selectedExplanationItem"
                        [disabled]="(dstSharedService.user.roleLevel < 2) || this.dstSharedService.isFiled"
                        (onSelect)="reviewerExplanationChange($event, rowData)">
                        @for (item of rowData['revExplanations_' + rowData.id]; track $index) {
                          <ap-dropdown-list-item #dropdownListItem [item]="item"
                            [ariaLabel]="setAriaLabel(item, 'Reviewer Explanation')"
                            (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                        }
                      </ap-dropdown>
                    </div>
                  }
                  @if (rowData.REVIEWNAME === 'Other: Explain') {
                    <div class="col-md-2 pl-0">
                      <span class="Appkit4-icon icon-pencil-outline pt-2" (click)="otherExplanation(rowData)"></span>
                    </div>
                  }
                </div>
              }
              @if (rowData.REVIEWNAME === 'N/A') {
                <span>N/A</span>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="ISREVIEWED">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [ngStyle]="getColStyle(getColByField('ISREVIEWED'))">
              {{ getColByField('ISREVIEWED').header }}
            </th>
            <td mat-cell *matCellDef="let rowData" class="item-aligned"
              [ngStyle]="getColStyle(getColByField('ISREVIEWED'))">
              <ap-checkbox [styleClass]="'a-mx-10'" [ngModel]="rowData.ISREVIEWED === 'Reviewed'"
                (onChange)="statementReviewedChange($event, rowData)"
                [disabled]="(dstSharedService.user.roleLevel < 2) || this.dstSharedService.isFiled">
              </ap-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="TAXYEAR_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(getColByField('TAXYEAR'))"></th>
          </ng-container>

          <ng-container matColumnDef="STATEMENTID_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(getColByField('STATEMENTID'))">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fStatementId"
                (input)="filterCol($event, 'STATEMENTID', 'contains')">
            </th>
          </ng-container>

          <ng-container matColumnDef="STATEMENTNAME_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(getColByField('STATEMENTNAME'))">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fStatementName"
                (input)="filterCol($event, 'STATEMENTNAME', 'contains')">
            </th>
          </ng-container>

          <ng-container matColumnDef="DATACOLLECT_ACTION_FLAG_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(getColByField('DATACOLLECT_ACTION_FLAG'))">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fActionFlag"
                (input)="filterCol($event, 'DATACOLLECT_ACTION_FLAG', 'startsWith')">
            </th>
          </ng-container>

          <ng-container matColumnDef="DATACOLLECT_ACTION_EXPL_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(getColByField('DATACOLLECT_ACTION_EXPL'))">
              <input type="text" class="dst-mat-col-filter" [(ngModel)]="fActionRequired"
                (input)="filterCol($event, 'DATACOLLECT_ACTION_EXPL', 'contains')">
            </th>
          </ng-container>

          <ng-container matColumnDef="REVIEWNAME_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(getColByField('REVIEWNAME'))"></th>
          </ng-container>

          <ng-container matColumnDef="ISREVIEWED_filter">
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getColStyle(getColByField('ISREVIEWED'))"></th>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" style="height: 45px;"></tr>
          <tr mat-header-row *matHeaderRowDef="filterColumns; sticky: true" class="dst-mat-filter-row"
            style="height: 45px;"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height: 70px;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell dst-mat-no-records" [attr.colspan]="displayedColumns.length">
              <span>No records.</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>

  @if (showModalViewer) {
    <dst-disc-modal-viewer [rowObject]="activeRow" (afterModalClosed)="afterModalClosed()">
    </dst-disc-modal-viewer>
  }

</div>

@if (showOtherExplanationModal) {
  <ap-modal #otherExplanationModal [appModalId]="'rev-other-exp'"
    [ariaLabel]="otherExplActiveRow.STATEMENTID + ' - Other: Explain'"
    [title]="otherExplActiveRow.STATEMENTID + ' - Other: Explain'" [closable]="true"
    [style]="{'width': '31.25rem'}" [styleClass]="'gtw-web-components dst-modal-sm'"
    (onClose)="onOtherExplanationCancel('rev-other-exp')">

    <div class="dc-report-modal-body">
      <p>Please Enter Other Explanation to Save.</p>
      <ap-field [styleClass]="'other-expl-height'" [title]="''"
        [disabled]="(dstSharedService.user.roleLevel < 2) || this.dstSharedService.isFiled">
        <textarea appkit-field [(ngModel)]="otherExplanationText" aria-label="Other explanation"></textarea>
      </ap-field>
    </div>

    <ng-template ngTemplate="footer">
      <ap-button [compact]="true" [btnType]="'primary'" class="ap-mr-spacing-3" [label]="'Save'"
        (onClick)="onOtherExplanationSave('rev-other-exp')"
        [disabled]="(dstSharedService.user.roleLevel < 2) || this.dstSharedService.isFiled"></ap-button>
      <ap-button [compact]="true" [btnType]="'secondary'" [label]="'Cancel'"
        (onClick)="onOtherExplanationCancel('rev-other-exp')"></ap-button>
    </ng-template>
  </ap-modal>
}
